<template>
  <div id="app">
    <AnnouncementBanner />
    <TopBar />
    <NavigationBar :key="`navigation-bar ${route.fullPath}`" />
    <!-- <GdprConsent /> -->
    <router-view :key="route.fullPath" />
    <AppFooter />
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'
import NavigationBar from './components/NavigationBar.vue'
import AnnouncementBanner from './components/AnnouncementBanner.vue'
// import GdprConsent from './components/GdprConsent.vue'
import AppFooter from './components/Footer.vue'
import { useRoute } from 'vue-router'

import './variables.css'
import './layout.css'

export default {
  components: {
    TopBar,
    NavigationBar,
    AppFooter,
    AnnouncementBanner,
    // GdprConsent,
  },

  setup() {
    const route = useRoute()
    return { route }
  },

  computed: {
    showLeaderboardButton() {
      return this.$route.path !== '/leaderboard'
    },
  },
}
</script>

<style lang="scss">
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
main {
  display: block;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
pre {
  font-family: monospace, monospace;
  font-size: 1em;
}
a {
  background-color: transparent;
  text-decoration: none;
  color: white;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}
b,
strong {
  font-weight: bolder;
}
code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
img {
  border-style: none;
}
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
[type='button'],
[type='reset'],
[type='submit'],
button {
  -webkit-appearance: button;
}
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring,
button:-moz-focusring {
  outline: 1px dotted ButtonText;
}
fieldset {
  padding: 0.35em 0.75em 0.625em;
}
legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
textarea {
  overflow: auto;
}
[type='checkbox'],
[type='radio'] {
  box-sizing: border-box;
  padding: 0;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
details {
  display: block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none;
}

/* lato-300 - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  src: url('./fonts/lato-v20-latin-300.eot'); /* IE9 Compat Modes */
  src: local(''), url('./fonts/lato-v20-latin-300.eot?#iefix') format('embedded-opentype'),
    /* IE6-IE8 */ url('./fonts/lato-v20-latin-300.woff2') format('woff2'),
    /* Super Modern Browsers */ url('./fonts/lato-v20-latin-300.woff') format('woff'),
    /* Modern Browsers */ url('./fonts/lato-v20-latin-300.ttf') format('truetype'),
    /* Safari, Android, iOS */ url('./fonts/lato-v20-latin-300.svg#Lato') format('svg'); /* Legacy iOS */
}
/* lato-regular - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  src: url('./fonts/lato-v20-latin-regular.eot'); /* IE9 Compat Modes */
  src: local(''), url('./fonts/lato-v20-latin-regular.eot?#iefix') format('embedded-opentype'),
    /* IE6-IE8 */ url('./fonts/lato-v20-latin-regular.woff2') format('woff2'),
    /* Super Modern Browsers */ url('./fonts/lato-v20-latin-regular.woff') format('woff'),
    /* Modern Browsers */ url('./fonts/lato-v20-latin-regular.ttf') format('truetype'),
    /* Safari, Android, iOS */ url('./fonts/lato-v20-latin-regular.svg#Lato') format('svg'); /* Legacy iOS */
}
/* lato-700 - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  src: url('./fonts/lato-v20-latin-700.eot'); /* IE9 Compat Modes */
  src: local(''), url('./fonts/lato-v20-latin-700.eot?#iefix') format('embedded-opentype'),
    /* IE6-IE8 */ url('./fonts/lato-v20-latin-700.woff2') format('woff2'),
    /* Super Modern Browsers */ url('./fonts/lato-v20-latin-700.woff') format('woff'),
    /* Modern Browsers */ url('./fonts/lato-v20-latin-700.ttf') format('truetype'),
    /* Safari, Android, iOS */ url('./fonts/lato-v20-latin-700.svg#Lato') format('svg'); /* Legacy iOS */
}

/* Main styles */
$font-family: 'Lato', Helvetica, Arial, sans-serif;
$font-size: 16px;
$font-weight: 400;
$font-bold: 700;
$font-lighter: 300;
$font-color: #ffffff !important;

/* HNFT colors */
$hnft-color-one: #252525;
$hnft-color-two: #353535;
$hnft-color-three: #454545;
$hnft-color-four: #555555;
$hnft-color-five: #656565;

$color-grey: #ffffff54;

$color-white: #fff;
$background-color-white: #fff;
$background-color-grey: #efeeee;
$background-color-grey-darker: #e2e2e2;

$main-width: 1400px;

$border-radius: 4px;

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Hide focus styles if they're not needed, for example,
when an element receives focus via the mouse. */
:focus:not(:focus-visible) {
  outline: 0;
}

/* Show focus styles on keyboard focus. */
:focus-visible {
  outline: 0;
}

/* Select lib */
#select2-collections-container {
  color: $hnft-color-five;
}

.select2-container--default .select2-results__option--highlighted {
  background-color: $hnft-color-five !important;
  cursor: pointer;
  color: white !important;
}

.select2-container--default .select2-results__option[aria-selected='true'] {
  background-color: $hnft-color-five;
  color: white;
}

.select2-container--default .select2-results__option[aria-selected='false'] {
  color: $hnft-color-five;
}

.select2-container--default .select2-selection--single {
  background-color: $hnft-color-five;
  border: 1px solid $hnft-color-five;
  text-align: center;
  text-transform: uppercase;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  color: $hnft-color-five;
  border: 1px solid $hnft-color-five;
}

/* Simplebar */
.simplebar-scrollbar:before {
  background-color: $hnft-color-five !important;
}

html,
body {
  display: flex;
  justify-content: center;
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  width: 100%;
  min-height: 100%;
  background-color: $hnft-color-two;
  color: $color-white;
  #app-wrapper {
    display: flex;
    max-width: 100%;
    justify-content: space-around;
    #app {
      display: flex;
      flex-direction: column;
      min-width: 100%;
      background-color: $hnft-color-one;
      border-radius: $border-radius;
      #section_one {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        background-color: $hnft-color-one;
        font-size: 0.8rem;
        padding: 1.5rem 1.5rem 0.5rem 1.5rem;
        text-transform: uppercase;
        white-space: nowrap;
        -webkit-border-bottom-right-radius: 4px;
        -webkit-border-bottom-left-radius: 4px;
        -moz-border-radius-bottomright: 4px;
        -moz-border-radius-bottomleft: 4px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        .left {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          font-weight: $font-bold;
          div {
            padding: 0.25rem;
            margin: 0.25rem;
            border: 1px solid $hnft-color-three;
            background-color: $hnft-color-five;
            color: $color-white;
            border-radius: $border-radius;
            span {
              font-weight: $font-lighter;
            }
          }
        }
        .right {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          button {
            padding: 0.25rem;
            margin: 0.25rem;
            border: 1px solid $hnft-color-three;
            background-color: $hnft-color-one;
            outline: none;
            color: $color-white;
            border-radius: $border-radius;
            &.selected {
              color: $color-white;
              background-color: $hnft-color-five;
            }
            &:hover {
              cursor: pointer;
              color: $color-white;
              background-color: $hnft-color-five;
            }
          }
        }
      }
      #section_three {
        display: flex;
        justify-content: center;
        padding: 1rem;
        -webkit-border-top-left-radius: 4px;
        -webkit-border-top-right-radius: 4px;
        -moz-border-radius-topleft: 4px;
        -moz-border-radius-topright: 4px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        img {
          display: block;
          width: 100%;
          max-width: 15rem;
          height: auto;
        }
      }
      #section_four {
        margin-top: 30px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 0rem 1rem;
        select {
          width: 100%;
          min-width: 500px;
          max-width: 500px;
        }
      }
      #section_five {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 0.5rem;
        h3 {
          background-color: $hnft-color-five;
          padding: 0.7rem 1rem;
          color: $color-white;
          font-size: 0.8rem;
          text-transform: uppercase;
          -webkit-border-top-left-radius: $border-radius;
          -webkit-border-top-right-radius: $border-radius;
          -moz-border-radius-topleft: $border-radius;
          -moz-border-radius-topright: $border-radius;
          border-top-left-radius: $border-radius;
          border-top-right-radius: $border-radius;
          border: 1px solid $hnft-color-five;
        }
        #latest_sales,
        #latest_listings {
          display: flex;
          flex-direction: column;
          flex-basis: 50%;
          min-width: 0;
          color: $color-white;
          background-color: $hnft-color-one;
          border: 1px solid $hnft-color-five;
          border-radius: $border-radius;
          margin: 0.5rem;
          .sales,
          .listings {
            display: flex;
            flex-direction: column;
            padding: 0.5rem;
            font-size: 0.9rem;
            color: $color-white;
            .sale,
            .listing {
              display: flex;
              flex-direction: row;
              flex-grow: 0;
              color: $color-white;
              flex-wrap: nowrap;
              justify-content: space-between;
              padding: 0.5rem;
              background-color: $hnft-color-two;
              border-radius: $border-radius;
              margin-bottom: 0.5rem;
              text-decoration: none;
              .name {
                padding: 0.2rem 1rem 0.2rem 0.2rem;
                white-space: nowrap;
                overflow: hidden;
                min-width: 0;
                text-overflow: ellipsis;
                max-width: 450px;
                width: 100%;
              }
              .price {
                position: relative;
                display: block;
                white-space: nowrap;
                background-color: $hnft-color-five;
                color: $color-white;
                padding: 0.2rem 0.3rem;
                border-radius: $border-radius;
              }
              &:hover,
              &:visited,
              &:active,
              &:focus {
                color: $color-white;
                background-color: $hnft-color-three;
              }
              &:last-child {
                margin-bottom: 0rem;
              }
            }
          }
        }
      }
      #section_six {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 1.5rem;
        #asset {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          background-color: $hnft-color-one;
          border-radius: $border-radius;
          h3 {
            box-shadow: 0 0 0 1px $hnft-color-five;
            background-color: $hnft-color-five;
            padding: 0.7rem 1rem;
            color: $color-white;
            font-size: 0.9rem;
            text-transform: uppercase;
            margin-top: 1rem;
            white-space: nowrap;
            border-radius: $border-radius;
            border: 1px solid $hnft-color-five;
            -webkit-border-radius: $border-radius;
            -webkit-border-bottom-right-radius: 0px;
            -webkit-border-bottom-left-radius: 0px;
            -moz-border-radius: $border-radius;
            -moz-border-radius-bottomright: 0px;
            -moz-border-radius-bottomleft: 0px;
            border-radius: $border-radius;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
          }
          .left,
          .right {
            display: flex;
            padding: 0.5rem;
            background-color: $hnft-color-one;
            border-radius: $border-radius;
            .content {
              padding: 1rem;
              background-color: $hnft-color-one;
              -webkit-border-bottom-right-radius: $border-radius;
              -webkit-border-bottom-left-radius: $border-radius;
              -moz-border-radius-bottomright: $border-radius;
              -moz-border-radius-bottomleft: $border-radius;
              border-bottom-right-radius: $border-radius;
              border-bottom-left-radius: $border-radius;
              box-shadow: 0 0 0 1px $hnft-color-five;
              max-height: 372px;
              margin-bottom: 0.5rem;
              overflow-y: auto;
              overflow-x: auto;
              .floor_price {
                font-size: 1.5rem;
                font-weight: $font-bold;
                span {
                  font-weight: $font-lighter;
                }
              }
              a {
                display: inline-block;
                color: $color-white;
                background-color: $hnft-color-five;
                padding: 0.5rem;
                border-radius: $border-radius;
                text-decoration: none;
                font-size: 0.8rem;
                margin-top: 0.5rem;
                margin-right: 0.5rem;
                border: 1px solid $hnft-color-five;
                &:hover,
                &:active,
                &:focus,
                &.active {
                  color: $color-white;
                  background-color: $hnft-color-five;
                }
              }
              table {
                width: 100%;
                text-align: center;
                border-spacing: 0; /* Removes the cell spacing via CSS */
                border-collapse: collapse; /* Optional - if you don't want to have double border where cells touch */
                font-size: 0.8rem;
                -webkit-border-top-left-radius: $border-radius;
                -webkit-border-top-right-radius: $border-radius;
                -moz-border-radius-topleft: $border-radius;
                -moz-border-radius-topright: $border-radius;
                border-top-left-radius: $border-radius;
                border-top-right-radius: $border-radius;
                .header {
                  background-color: $hnft-color-five;
                }
                thead {
                  tr {
                    background-color: $hnft-color-five;
                    &:nth-child(odd) {
                      background-color: $hnft-color-two;
                    }
                  }
                  th {
                    background-color: $hnft-color-five;
                    color: $color-white;
                    &:first-child {
                      -webkit-border-radius: 0px;
                      -webkit-border-top-left-radius: $border-radius;
                      -moz-border-radius: 0px;
                      -moz-border-radius-topleft: $border-radius;
                      border-radius: 0px;
                      border-top-left-radius: $border-radius;
                    }
                    &:last-child {
                      -webkit-border-radius: 0px;
                      -webkit-border-top-right-radius: $border-radius;
                      -moz-border-radius: 0px;
                      -moz-border-radius-topright: $border-radius;
                      border-radius: 0px;
                      border-top-right-radius: $border-radius;
                    }
                  }
                }
                th,
                td {
                  padding: 0.5rem;
                  border-bottom: 1px solid $hnft-color-five;
                  overflow: hidden;
                  text-transform: uppercase;
                  overflow-wrap: break-word;

                  &:first-child {
                    text-align: left;
                    font-weight: $font-bold;
                  }
                  &:last-child {
                    text-align: right;
                  }
                }
                tbody {
                  tr {
                    &:hover {
                      background-color: $hnft-color-two;
                    }
                    td {
                      .price {
                        font-weight: $font-bold;
                        display: block;
                      }
                      .link {
                        padding: 0.2rem 0.2rem 0rem 0.2rem;
                        background-color: $hnft-color-five;
                        color: $color-white;
                        margin-top: 0rem;
                      }
                    }
                  }
                }
              }
            }
          }
          .left {
            display: flex;
            flex-direction: column;
            margin-right: 0.5rem;
            max-width: 20%;
            flex-shrink: 0;
            flex-grow: 0;
            #collections {
              span {
                display: block;
                width: 100%;
                margin-bottom: 0.3rem;
              }
            }
            .content {
              max-height: 300px;
            }
            img {
              border-radius: $border-radius;
              width: 100%;
              min-height: 1px;
              height: auto;
              align-self: flex-start;
            }
            .asset_image {
              position: relative;
              display: block;
              .image_toggle {
                display: block;
                position: absolute;
                z-index: 2;
                padding: 0.7rem;
                color: $color-white;
                background-color: $hnft-color-five;
                border-radius: $border-radius;
                top: 0;
                right: 0;
                cursor: pointer;
              }
            }
          }
          .right {
            display: flex;
            flex-direction: column;
            flex-shrink: 1;
            flex-grow: 1;
            margin-left: 0.5rem;
            max-width: 80%;
            > div:nth-child(2) {
              h3 {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background-color: $hnft-color-five;
                color: $color-white;
                margin-top: 0rem;
                font-size: 1rem;
                .last_update {
                  font-size: 0.6rem;
                }
              }
            }
            img {
              border-radius: $border-radius;
              width: 100%;
              min-height: 1px;
              height: auto;
              align-self: flex-start;
            }
            .asset_image {
              position: relative;
              display: none;
              .image_toggle {
                display: block;
                position: absolute;
                z-index: 2;
                padding: 0.7rem;
                color: $color-white;
                background-color: $hnft-color-five;
                border-radius: $border-radius;
                top: 0;
                right: 0;
                cursor: pointer;
              }
            }
          }
        }
        #assetTable {
          display: flex;
          flex-direction: column;
          font-size: 0.8rem;
          overflow-x: hidden;
          a {
            text-decoration: none !important;
            color: $font-color;
          }
          .tableRow {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            border-bottom: 1px solid $hnft-color-five;
            &:hover {
              background-color: $hnft-color-two;
            }
            .tableColumn {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              flex-grow: 1;
              flex-shrink: 1;
              padding: 0.6rem;
              text-align: center;
              width: 10%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              &.image {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                font-weight: $font-bold;
                img {
                  display: block;
                  width: 40px;
                  min-height: 1px;
                  margin-right: 1rem;
                }
              }
              .price {
                font-weight: $font-bold;
                padding: 0.2rem;
                border-radius: $border-radius;
                background-color: $hnft-color-five;
                color: $color-white;
                margin-bottom: 0.2rem;
              }
              &:first-child {
                width: 13.333333333333%;
                text-align: left;
              }
              &.header {
                display: flex;
                flex-direction: row;
                background-color: $hnft-color-five;
                color: $color-white;
                text-transform: uppercase;
                font-weight: $font-bold;
                cursor: pointer;
                white-space: nowrap;
                &:hover {
                  text-decoration: underline;
                }
                &:first-child {
                  justify-content: left;
                  -webkit-border-radius: 0px;
                  -webkit-border-top-left-radius: $border-radius;
                  -moz-border-radius: 0px;
                  -moz-border-radius-topleft: $border-radius;
                  border-radius: 0px;
                  border-top-left-radius: $border-radius;
                }
                &:last-child {
                  -webkit-border-radius: 0px;
                  -webkit-border-top-right-radius: $border-radius;
                  -moz-border-radius: 0px;
                  -moz-border-radius-topright: $border-radius;
                  border-radius: 0px;
                  border-top-right-radius: $border-radius;
                }
                svg {
                  position: relative;
                  top: 3px;
                }
              }
            }
          }
        }
      }
      #section_seven {
        display: flex;
        flex-direction: column;
        text-align: center;
        background-color: $hnft-color-four;
        color: $color-white;
        font-size: 0.8rem;
        padding: 1rem;
        div {
          margin-bottom: 0.5rem;
        }
        a {
          color: $font-color;
          text-decoration: none;
          padding: 0rem 0.2rem;
          &:hover,
          &:visited,
          &:active,
          &:focus {
            color: $hnft-color-five;
          }
        }
        .donate {
          display: flex;
          font-size: 0.7rem;
          flex-direction: row;
          margin: 0 auto 1rem auto;
          span {
            color: $color-white;
            padding: 0.2rem;
            border: 1px solid $color-white;
            background-color: $hnft-color-one;
            -webkit-border-top-right-radius: $border-radius;
            -webkit-border-bottom-right-radius: $border-radius;
            -moz-border-radius-topright: $border-radius;
            -moz-border-radius-bottomright: $border-radius;
            border-top-right-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
            &:first-child {
              background-color: $hnft-color-five;
              color: $color-white;
              text-transform: uppercase;
              -webkit-border-radius: 0px;
              -webkit-border-top-left-radius: $border-radius;
              -webkit-border-bottom-left-radius: $border-radius;
              -moz-border-radius: 0px;
              -moz-border-radius-topleft: $border-radius;
              -moz-border-radius-bottomleft: $border-radius;
              border-radius: 0px;
              border-top-left-radius: $border-radius;
              border-bottom-left-radius: $border-radius;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1270px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 400px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1220px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 350px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1170px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 300px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1120px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 300px;
                }
              }
            }
          }
        }
        #section_six {
          display: flex;
          order: 6;
          #asset {
            display: flex;
            flex-direction: column;
            .left {
              order: 2;
              margin-right: 0;
              -webkit-border-top-left-radius: 0px;
              -webkit-border-top-right-radius: 0px;
              -moz-border-radius-topleft: 0px;
              -moz-border-radius-topright: 0px;
              border-top-left-radius: 0px;
              border-top-right-radius: 0px;
              max-width: inherit;
              padding-top: 0;
              .asset_image {
                display: none;
              }
            }
            .right {
              order: 1;
              margin-left: 0;
              -webkit-border-bottom-right-radius: 0px;
              -webkit-border-bottom-left-radius: 0px;
              -moz-border-radius-bottomright: 0px;
              -moz-border-radius-bottomleft: 0px;
              border-bottom-right-radius: 0px;
              border-bottom-left-radius: 0px;
              max-width: inherit;
              padding-bottom: 0;
              img {
                display: block;
                max-width: 200px;
                margin: 0 auto 0.5rem auto;
              }
              .asset_image {
                display: block;
              }
            }
          }
          #assetTable {
            font-size: 0.6rem;
          }
        }
        #section_seven {
          order: 7;
          .donate {
            flex-direction: column;
            span {
              -webkit-border-radius: 0px;
              -webkit-border-bottom-right-radius: $border-radius;
              -webkit-border-bottom-left-radius: $border-radius;
              -moz-border-radius: 0px;
              -moz-border-radius-bottomright: $border-radius;
              -moz-border-radius-bottomleft: $border-radius;
              border-radius: 0px;
              border-bottom-right-radius: $border-radius;
              border-bottom-left-radius: $border-radius;
              &:first-child {
                background-color: $hnft-color-five;
                color: $color-white;
                text-transform: uppercase;
                -webkit-border-radius: $border-radius;
                -webkit-border-bottom-right-radius: 0px;
                -webkit-border-bottom-left-radius: 0px;
                -moz-border-radius: $border-radius;
                -moz-border-radius-bottomright: 0px;
                -moz-border-radius-bottomleft: 0px;
                border-radius: $border-radius;
                border-bottom-right-radius: 0px;
                border-bottom-left-radius: 0px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1070px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings,
            .listing {
              .sale {
                .name {
                  max-width: 250px;
                }
              }
            }
          }
        }
        #section_six {
          #assetTable {
            .tableRow {
              .tableColumn {
                &:first-child {
                  width: 20%;
                  text-align: left;
                }
                &:nth-child(5) {
                  -webkit-border-radius: 0px;
                  -webkit-border-top-right-radius: $border-radius;
                  -moz-border-radius: 0px;
                  -moz-border-radius-topright: $border-radius;
                  border-radius: 0px;
                  border-top-right-radius: $border-radius;
                }
                &:nth-child(6),
                &:nth-child(7) {
                  display: none;
                  width: 15%;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1020px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 200px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 830px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_six {
          #assetTable {
            .tableRow {
              .tableColumn {
                &:first-child {
                  width: 30%;
                  text-align: left;
                }
                &:nth-child(4) {
                  -webkit-border-radius: 0px;
                  -webkit-border-top-right-radius: $border-radius;
                  -moz-border-radius: 0px;
                  -moz-border-radius-topright: $border-radius;
                  border-radius: 0px;
                  border-top-right-radius: $border-radius;
                }
                &:nth-child(5) {
                  display: none;
                  width: 23.33333333%;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .select2-container--default .select2-selection--single,
  .select2-container--open .select2-dropdown--below {
    border-radius: 0;
  }
  html,
  body {
    #app-wrapper {
      padding: 0rem;
      border-radius: 0;
      #app {
        #section_one {
          display: flex;
          flex-direction: column;
          order: 0;
          .left {
            width: 100%;
            div {
              flex-basis: 40%;
              flex-grow: 1;
              flex-shrink: 1;
              text-align: center;
            }
          }
          .right {
            flex-wrap: nowrap;
            width: 100%;
            button {
              flex-basis: 25%;
              flex-grow: 1;
              flex-shrink: 1;
              text-align: center;
            }
          }
        }
        #section_three {
          display: flex;
          order: 1;
          img {
            max-width: 15rem;
          }
        }
        #section_four {
          padding: 0rem 1rem;
          margin-top: 2rem;
          order: 4;
          select {
            width: 100%;
            min-width: auto;
            max-width: 100%;
          }
        }
        #section_five {
          display: flex;
          flex-direction: column;
          font-size: 0.8rem;
          order: 5;
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 450px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.sub-section {
  width: 100%;
  text-align: center;
  border-spacing: 0; /* Removes the cell spacing via CSS */
  border-collapse: collapse; /* Optional - if you don't want to have double border where cells touch */
  font-size: 0.8rem;

  .sub-section-header {
    -webkit-border-top-left-radius: $border-radius;
    -webkit-border-top-right-radius: $border-radius;
    -moz-border-radius-topleft: $border-radius;
    -moz-border-radius-topright: $border-radius;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;

    background-color: $hnft-color-five;
    color: $color-white;
    padding: 0.5rem;
    border-bottom: 1px solid $hnft-color-five;
    overflow: hidden;
    white-space: nowrap;
    text-transform: uppercase;
  }
}

@media (max-width: 717px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 400px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 667px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 350px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 617px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 300px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 567px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 250px;
                }
              }
            }
          }
        }
        #section_six {
          #assetTable {
            .tableRow {
              .tableColumn {
                &:first-child {
                  width: 35%;
                  text-align: left;
                }
                &:nth-child(3) {
                  -webkit-border-radius: 0px;
                  -webkit-border-top-right-radius: $border-radius;
                  -moz-border-radius: 0px;
                  -moz-border-radius-topright: $border-radius;
                  border-radius: 0px;
                  border-top-right-radius: $border-radius;
                }
                &:nth-child(4) {
                  display: none;
                  width: 32.5%;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 517px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 250px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 467px) {
  html,
  body {
    #app-wrapper {
      #app {
        #section_five {
          #latest_sales,
          #latest_listings {
            .sales,
            .listings {
              .sale,
              .listing {
                .name {
                  max-width: 150px;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Added CSS here because was lazy to figure out how variables were exported in other files
.secondary-text {
  color: var(--grey-two);
  font-weight: normal;
}

// Pagination
.pagination {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  justify-content: center;
  margin-top: 1rem;
  padding: 0.5rem;
}

.c-sliding-pagination__list-element {
  background-color: var(--grey-one);
}

#pagination ul {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  justify-content: center;
  margin-top: 1rem;
}

#pagination li {
  display: flex;
  flex-shrink: 1;
  margin: 0.25rem;
  justify-content: center;
  align-items: center;
  border-radius: var(--border-radius);
  cursor: pointer;
  font-weight: var(--font-bold);
  background-color: var(--grey-one);
  font-size: 0.8rem;
  padding: 0;
}

#pagination li a {
  color: var(--font-color);
  padding: 0.5rem;
}

#pagination li a:hover,
.c-sliding-pagination__page--current {
  color: var(--white);
}

.c-sliding-pagination__list-element--active a,
.c-sliding-pagination__list-element--active a:hover {
  background-color: var(--grey-one);
  border: 1px solid white;
  border-radius: 4px;
}

@media only screen and (max-width: 767px) {
  #pagination li {
    font-size: 0.6rem;
    margin: 0.2rem;
  }
}
</style>
